import React from "react";

import { useStaticQuery, graphql, navigate } from "gatsby";

import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import SettingsIcon from "@mui/icons-material/Settings";
import { useExtendedTheme } from "@theme/Context";
import { Button, Tab, Tabs } from "@mui/material";

import AppBarMenu from "./Menu";

const appBarQuery = graphql`
  query AppBarQuery {
    avatar: contentfulAsset(title: { eq: "avatar" }) {
      title
      url
      description
    }
    autoGeneratedPages: allContentfulPageContent(sort: { order: ASC }) {
      nodes {
        path
        pageName
        order
      }
    }
  }
`;

type ResponsiveAppBarProps = {
  path?: string;
};
const ResponsiveAppBar = ({ path }: ResponsiveAppBarProps) => {
  const appBarData = useStaticQuery(appBarQuery);
  const avatar = appBarData.avatar;
  const autoGeneratedPages = appBarData.autoGeneratedPages.nodes;

  const { toggleTheme, theme } = useExtendedTheme();

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="static"
      sx={
        theme.palette.mode === "light"
          ? { background: theme.palette.primary.light }
          : {}
      }
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <IconButton href="/" sx={{ p: 0, mr: 1 }}>
            <Avatar alt={avatar.description} src={avatar.url} />
          </IconButton>
          <AppBarMenu
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            pages={autoGeneratedPages}
          />

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {autoGeneratedPages.map(
              ({ path, pageName }: { path: string; pageName: string }) => (
                <Button
                  key={`page-${pageName || "index"}`}
                  onClick={() => navigate(path || "/")}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  {pageName || "Home"}
                </Button>
              )
            )}
          </Box>

          <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <SettingsIcon />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={toggleTheme}>
                <Typography textAlign="center">Toggle Theme</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;
